import React from "react";

export function Crest({ club, size = 28 }) {
  if (!club) return null;
  const { primary, secondary, code } = club;
  return (
    <svg width={size} height={size} viewBox="0 0 40 44" aria-hidden="true" style={{ flexShrink: 0 }}>
      <path d="M2 2 H38 V26 Q38 40 20 43 Q2 40 2 26 Z" fill={primary} stroke={secondary} strokeWidth="2" />
      <path d="M2 2 H20 V43 Q2 40 2 26 Z" fill={secondary} opacity="0.18" />
      <text x="20" y="24" textAnchor="middle" fontFamily="Saira Condensed, sans-serif"
        fontWeight="800" fontSize="14" fill={secondary}>{code}</text>
    </svg>
  );
}

export function CoachAvatar({ name, size = 40, ring = "#ffb547" }) {
  const initials = (name || "?").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  return (
    <div
      className="rounded-full grid place-items-center font-display font-bold"
      style={{ width: size, height: size, background: "#1a1a1a", border: `2px solid ${ring}`, color: ring, fontSize: size * 0.38 }}
    >
      {initials}
    </div>
  );
}
